var map = {
	"./bookmark-blue.svg": 638,
	"./buildings-blue.svg": 639,
	"./buildings-gray.svg": 640,
	"./checkbox.svg": 641,
	"./cloud-inactive.svg": 40,
	"./cloud.svg": 642,
	"./document.svg": 643,
	"./edit-inactive.svg": 28,
	"./edit.svg": 644,
	"./info.svg": 288,
	"./no-print.svg": 289,
	"./opcje.svg": 210,
	"./question.svg": 287,
	"./settings.svg": 290,
	"./standard.svg": 296,
	"./student-blue.svg": 645,
	"./student-gray.svg": 646,
	"./table.svg": 647,
	"./text-field.svg": 648,
	"./vector.svg": 297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 637;